import { Component, ElementRef, ViewChild } from '@angular/core';

import { DestinationSpecialtiesService } from './destination-specialties.service';
import { SearchLocationData } from '@hiptraveler/common';
import { SnackbarService } from '@hiptraveler/snackbar';

@Component({
  selector: 'destination-specialties',
  templateUrl: './destination-specialties.component.html',
  styleUrls: ['./destination-specialties.component.scss'],
  host: { class: 'ta-register-registration-form-inline' },
  viewProviders: [ DestinationSpecialtiesService ]
})
export class DestinationSpecialtiesComponent {

  @ViewChild('searchLocation') input: ElementRef<HTMLInputElement>;

  constructor(
    public service: DestinationSpecialtiesService,
    private snackbar: SnackbarService
  ) { }

  async locationChanges(locationData: SearchLocationData): Promise<void> {

    try {
      this.input.nativeElement.value = '';
      this.input.nativeElement.disabled = true;
      await this.service.appendLocation(locationData, this.input);
    } catch (e) {
      this.snackbar.open({ message: 'This location is already on your list. Let’s explore a different destination to showcase your expertise!', duration: 5000 })
    } finally {
      this.input.nativeElement.disabled = false;
    }
  }

}
